export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/logo-mark.png"
    alt="Aspen Design mark"
    className={`${className} object-contain`}
  />
);

export const Logo = ({ dark = false }) => (
  <div
    className={`flex items-center gap-3 ${dark ? "text-navy-800" : "text-white"}`}
    data-testid="brand-logo"
  >
    <LogoMark className="h-9 w-9 shrink-0" />
    <div className="leading-none">
      <span className="block font-serif text-base font-semibold tracking-[0.22em]">
        ASPEN
      </span>
      <span className="mt-1 block text-[0.55rem] font-medium tracking-[0.5em] text-gold">
        DESIGN
      </span>
    </div>
  </div>
);
